/* eslint-disable import/no-anonymous-default-export */
import type { AxiosResponse } from "axios";
import apiClient from "@utilities/apiClient";
import EndpointsConst from "@consts/EndpointsConst";

class GeneralService {
  /**
   * [GET]
   * Adds a site view to the domain
   * @param domain - The domain the view should be recorded against
   */
  addSiteView(domain: string): Promise<AxiosResponse> {
    return apiClient.get(EndpointsConst.API.GENERAL.ADD_SITE_VIEW, {
      params: { domain },
    });
  }

  /**
   * [GET]
   * Retrieves site view count from database
   * @param domain - The domain whose view count should be retrieved
   */
  getSiteViewCount(domain: string): Promise<AxiosResponse<number>> {
    return apiClient.get(EndpointsConst.API.GENERAL.GET_SITE_VIEW_COUNT, {
      params: { domain },
    });
  }
}

export default new GeneralService();
